import { Dayjs } from 'dayjs';

import { formatDuration } from '../utils/format-duration';
import { useNow } from '../utils/use-now';

export function ElapsedTime(props: { date: Date | Dayjs }) {
  const now = useNow();
  return <>{formatDuration(props.date, now)} ago</>;
}
